function DotChecked(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx={8.795}
        cy={8.795}
        r={7.295}
        fill="#17D220"
        stroke="#fff"
        strokeWidth={3}
      />
      <path
        d="M8.308 9.683L5.84 7.215 5 8.049l3.308 3.309 7.102-7.102-.835-.835-6.267 6.262z"
        fill="#fff"
      />
    </svg>
  )
}

export default DotChecked
